import React, { useState } from "react";
import Box from "@mui/material/Box";

import SearchScanner from "../capture/SearchScanner";
import TableSearch from "../TablePro/TableSearch";
import AdvancedSearch from "../AdvancedSearch/index";

export default function AssetsSearch({
  search,
  setSearch,
  loading,
  receivingWizard,
  fields,
}) {
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);

  if (receivingWizard) {
    return (
      <Box minWidth={{ sm: 400 }} bgcolor="white" borderRadius={4}>
        <SearchScanner
          value={search}
          setSearch={setSearch}
          showNAButton={false}
          onAdvancedSearchClick={() => setShowAdvancedSearch(true)}
        />
        <Box position="relative">
          {showAdvancedSearch && (
            <AdvancedSearch
              initialValue={search}
              onSearch={setSearch}
              onCancel={() => setShowAdvancedSearch(false)}
              fields={fields}
            />
          )}
        </Box>
      </Box>
    );
  }

  return (
    <TableSearch
      placeholder="Search assets"
      disabled={loading}
      onChange={setSearch}
      value={search}
      fields={fields}
    />
  );
}
